import { useState, memo } from "react";
import Swal from "sweetalert2";
import AnimacionCarga from "./animacion_de_carga";
import LogoLetras from "../../assets/coordi_ph_logo_letras_2.png";
import "../css/registro.css";
import "../css/parametros_globales.css";

const URL_REGISTRO = "https://coordiph.herokuapp.com/registro/enviarverificacion";

const MENSAJES_REGISTRO = {
  "cliente no existe": "El código del cliente que ingresaste no cuenta con CoordiPH",
  "email address is already in use": "El correo ingresado ya se encuentra registrado",
  "email-already-in-use": "El correo ingresado ya se encuentra registrado",
  "weak-password": "La contraseña es muy débil, use al menos 6 caracteres",
  "invalid-email": "El correo electrónico no es válido",
  "network-request-failed": "Sin conexión a internet, verifique su red e intente nuevamente",
  "server-unavailable": "El servicio no está disponible en este momento, por favor intente más tarde o contacte al administrador.",
  "error": "Ahora no es posible realizar el registro, intente más tarde",
};

const Registro = memo(() => {
  const [cargando, setCargando] = useState(false);
  const [form, setForm] = useState({
    nombreCompleto: "",
    documento: "",
    celular: "",
    tipoVivienda: "APARTAMENTO",
    torre: "",
    numeroCasa: "",
    direccion: "",
    codigoCliente: "",
    correo: "",
    clave: "",
    clave2: "",
  });

  const actualizar = (campo, valor) => {
    setForm((prev) => {
      const nuevo = { ...prev, [campo]: valor };

      if (["tipoVivienda", "torre", "numeroCasa"].includes(campo)) {
        const tv = campo === "tipoVivienda" ? valor : nuevo.tipoVivienda;
        const t = campo === "torre" ? valor : nuevo.torre;
        const n = campo === "numeroCasa" ? valor : nuevo.numeroCasa;

        if (t && n) {
          nuevo.direccion =
            tv === "APARTAMENTO"
              ? `TORRE ${t} APARTAMENTO ${n}`
              : `MANZANA ${t} CASA ${n}`;
        }
      }

      return nuevo;
    });
  };

  const mostrarAlerta = (title, text, icon) =>
    Swal.fire({ title, text, icon, confirmButtonText: "Aceptar" });

  const registrar = async (e) => {
    e.preventDefault();

    const { nombreCompleto, celular, direccion, codigoCliente, correo, clave, clave2 } = form;

    if (!nombreCompleto || !celular || !direccion || !codigoCliente || !correo || !clave || !clave2) {
      mostrarAlerta("Campos incompletos", "Por favor diligencia todos los campos obligatorios.", "error");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(correo)) {
      mostrarAlerta("Correo inválido", "Ingresa un correo electrónico válido.", "error");
      return;
    }

    if (clave.length < 6) {
      mostrarAlerta("Contraseña débil", "La contraseña debe tener al menos 6 caracteres.", "error");
      return;
    }

    if (clave !== clave2) {
      mostrarAlerta("Contraseñas no coinciden", "Las contraseñas ingresadas no son iguales.", "error");
      return;
    }

    if (codigoCliente.trim().length < 2) {
      mostrarAlerta("Código inválido", "Se debe agregar el código del cliente para poder registrar la cuenta.", "error");
      return;
    }

    setCargando(true);

    const correoMinuscula = correo.toLowerCase().trim();
    const usuario = correoMinuscula.replaceAll("@", "").replaceAll(".", "");

    let documento = form.documento.trim();
    if (documento.length < 4) documento = "0";

    const pad = (n, l = 2) => String(n).padStart(l, "0");
    const ahora = new Date();
    const fecha = `${ahora.getFullYear()}-${pad(ahora.getMonth() + 1)}-${pad(ahora.getDate())} ${pad(ahora.getHours())}:${pad(ahora.getMinutes())}:${pad(ahora.getSeconds())}.${pad(ahora.getMilliseconds(), 3)}`;

    let mensajeCrudo;
    let exito = false;

    try {
      const resp = await fetch(URL_REGISTRO, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mail: correoMinuscula,
          user: usuario,
          fecha,
          Celular: celular.trim(),
          CodigoCliente: codigoCliente.trim(),
          Documento: documento,
          NombreCompleto: nombreCompleto.trim(),
          TelefonoAlterno: "0",
          pass: clave,
          direccion: direccion.trim(),
        }),
      });

      const texto = (await resp.text()).trim();
      const esHtml = texto.startsWith("<") || texto.includes("<!DOCTYPE");

      if (esHtml || resp.status >= 500) {
        mensajeCrudo = "server-unavailable";
      } else {
        try {
          const data = JSON.parse(texto);
          mensajeCrudo = String((data && (data.body ?? data.message)) ?? texto);
        } catch {
          mensajeCrudo = texto;
        }
      }

      exito = resp.ok && mensajeCrudo.toLowerCase().includes("usuario registrado");
    } catch {
      mensajeCrudo = "network-request-failed";
    }

    setCargando(false);

    if (exito) {
      await mostrarAlerta(
        "Registro exitoso",
        "Revisa tu correo y confirma tu cuenta. Luego un administrador aprobará tu ingreso y te notificaremos.",
        "success"
      );
      window.location.replace("/");
      return;
    }

    const crudoMinuscula = (mensajeCrudo || "").toLowerCase();
    let mensaje = null;
    for (const [patron, texto] of Object.entries(MENSAJES_REGISTRO)) {
      if (crudoMinuscula.includes(patron)) {
        mensaje = texto;
        break;
      }
    }
    if (!mensaje) mensaje = "Ahora no es posible realizar el registro, intente más tarde";

    mostrarAlerta("Error", mensaje, "error");
  };

  if (cargando) return <AnimacionCarga />;

  return (
    <div className="Registro">
      <img alt="CoordiPH" src={LogoLetras} />

      <br /><br />

      <form onSubmit={registrar}>
        <input
          className="campo"
          type="text"
          placeholder="Nombre completo *"
          value={form.nombreCompleto}
          onChange={(e) => actualizar("nombreCompleto", e.target.value)}
        />

        <input
          className="campo"
          type="text"
          placeholder="Número de documento (opcional)"
          value={form.documento}
          onChange={(e) => actualizar("documento", e.target.value)}
        />

        <input
          className="campo"
          type="text"
          placeholder="Número de celular *"
          value={form.celular}
          onChange={(e) => actualizar("celular", e.target.value)}
        />

        <div className="fila">
          <select
            className="campo"
            value={form.tipoVivienda}
            onChange={(e) => actualizar("tipoVivienda", e.target.value)}
          >
            <option value="APARTAMENTO">APARTAMENTO</option>
            <option value="CASA">CASA</option>
          </select>

          <input
            className="campo"
            type="text"
            placeholder="Torre / Etapa *"
            value={form.torre}
            onChange={(e) => actualizar("torre", e.target.value)}
          />

          <input
            className="campo"
            type="text"
            placeholder="No. Apto / Casa *"
            value={form.numeroCasa}
            onChange={(e) => actualizar("numeroCasa", e.target.value)}
          />
        </div>

        <input
          className="campo"
          type="text"
          placeholder="Dirección *"
          value={form.direccion}
          onChange={(e) => actualizar("direccion", e.target.value)}
        />

        <input
          className="campo"
          type="text"
          placeholder="NIT de la copropiedad *"
          value={form.codigoCliente}
          onChange={(e) => actualizar("codigoCliente", e.target.value)}
        />

        <input
          className="campo"
          type="email"
          placeholder="Correo electrónico *"
          value={form.correo}
          onChange={(e) => actualizar("correo", e.target.value)}
        />

        <input
          className="campo"
          type="password"
          placeholder="Contraseña * (mínimo 6 caracteres)"
          value={form.clave}
          onChange={(e) => actualizar("clave", e.target.value)}
        />

        <input
          className="campo"
          type="password"
          placeholder="Confirmar contraseña *"
          value={form.clave2}
          onChange={(e) => actualizar("clave2", e.target.value)}
        />

        <button type="submit" className="btn-registrar">REGISTRARME</button>
      </form>

      <p className="pie">
        ¿Ya tienes cuenta?{" "}
        <a href="/">Iniciar sesión</a>
      </p>

      <p style={{ textAlign: "center", margin: "4px 0 32px", fontSize: "12px", color: "#aaa" }}>
        Al registrarte aceptas nuestros{" "}
        <a href="/legal" style={{ color: "#ff4747", textDecoration: "none", fontWeight: "600" }}>
          Términos y Política de Privacidad
        </a>
      </p>
    </div>
  );
});

export default Registro;
